<script setup lang="ts">
  import {
    computed,
    nextTick,
    onActivated,
    onBeforeUnmount,
    onMounted,
    reactive,
    ref,
    watch,
  } from 'vue';
  import {
    actions as actionTypes,
    useUserComponent,
    useHelpers,
    createComponentScope,
    Resource,
    uniqueID,
  } from '@integro/core';
  import type { IAppHelpers } from '@integro/core';
  import * as _ from 'lodash';

  defineOptions({
    name: 'UcContractRentalCard',
  });

  const componentMetadata = {
    kind: 'usercontrol',
  };

  const emit = defineEmits(['reload', 'close', 'save']);

  const props = defineProps({
    rental: {
      type: Object,
      required: true,
    },
  });

  const {
    $app,
    $fn,
    $i18n,
    $store,
    $config,
    $imodal,
    $notification,
    $tabs,
    $route,
    $router,
    gettext,
    pgettext,
    ngettext,
    npgettext,
    schemaDefaults,
    getSchema,
    searchDataSource,
    randomElementId,
    datetime,
    date,
    time,
    number,
    money,
    distance,
    username,
    filesize,
  } = useHelpers();

  const ux = ref([]);

  const $data = computed(() => ({
    ux: ux.value,
  }));

  const {
    loading,
    error,
    loaded,
    reloading,
    showLoadingIndicator,
    loadDataThrottled,
    friendlyName,
    loadData,
    touchLastLoaded,
    handleError,
    setData,
    forms,
    registerForm,
    unregisterForm,
    canLoadData,
    isModalComponent,
    modalName,
    pageDocument: _pageDocument,
    routeTab,
    ux: _ux,
    componentMetadata: _componentMetadata,
    $uid,
    lastLoaded,
  } = useUserComponent(props, {
    metadata: componentMetadata,
    dataSpecs: [{ name: 'ux' }],
    loaders: {},
    ux: {},
    dataRefs: { ux },
  });

  const $component = createComponentScope(
    {
      $app,
      $fn,
      $i18n,
      $store,
      $imodal,
      $notification,
      $tabs,
      $router,
    } as IAppHelpers,
    {
      emit,
      forms,
      error,
      isModalComponent,
      modalName,
      componentMetadata,
      loadData,
      registerForm,
      unregisterForm,
      setData,
      touchLastLoaded,
      handleError,
    }
  );

  watch(
    () => props.rental,
    (newValue, oldValue) => {
      if (_.isEqual(newValue, oldValue)) return;
      loadDataThrottled('rental');
    }
  );

  const act_7315092382398562_reloadComponentData_ifebirhix =
    new actionTypes.ReloadComponentDataAction({});
  const inst_evh_7315092382398562_reload_iso5wb3eb =
    new actionTypes.EventHandlerImpl({
      action: act_7315092382398562_reloadComponentData_ifebirhix,
      event: 'reload',
      displayName: 'reloadComponentData',
    });
  const inst_evh_7315092382398562_reload = new actionTypes.EventHandlerGroup({
    handlers: [inst_evh_7315092382398562_reload_iso5wb3eb],
    event: 'reload',
  });

  const actions = {
    inst_evh_7315092382398562_reload_iso5wb3eb,
    inst_evh_7315092382398562_reload,
  };

  const evh_7315092382398562_reload_iso5wb3eb = async (event, scope) => {
    return await actions.inst_evh_7315092382398562_reload_iso5wb3eb.executeFromDOM(
      $component,
      event,
      scope
    );
  };
  const evh_7315092382398562_reload = async (event, scope) => {
    return await actions.inst_evh_7315092382398562_reload.executeFromDOM(
      $component,
      event,
      scope
    );
  };

  defineExpose({
    loadData,
    loading,
    loaded,
    error,
  });
</script>

<template>
  <ItpUsercontrol
    :loading="loading"
    :reloading="reloading"
    :loaded="loaded"
    :error="error"
    @reload="evh_7315092382398562_reload($event, {})"
  >
    <div v-if="rental.address">
      <ItpText muted>{{ pgettext('Rental', 'Address') }}:</ItpText>
      {{ rental.address }}
    </div>
    <div v-if="rental.area">
      <ItpText muted>{{ pgettext('Rental', 'Area') }}:</ItpText>
      {{ rental.area }}
    </div>
    <div v-if="rental.lot_number">
      <ItpText muted>{{ pgettext('Rental', 'LOT number') }}:</ItpText>
      {{ rental.lot_number }}
    </div>
    <div v-if="rental.house_number">
      <ItpText muted>{{ pgettext('Rental', 'House number') }}:</ItpText>
      {{ rental.house_number }}
    </div>
    <div v-if="rental.description">
      <ItpText muted>{{ pgettext('Rental', 'Description') }}:</ItpText>
      {{ rental.description }}
    </div>
  </ItpUsercontrol>
</template>
